import { Component } from 'preact';
import style from './styles/RaffleForm.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RaffleRepository from '../../repositories/RaffleRepository';
import ConsentRepository from '../../repositories/ConsentRepository';
import DeliveryRepository from '../../repositories/DeliveryRepository';
import {
	fetchingRaffleAction,
	fetchedRaffleAction,
	clearFetchedRaffleAction
} from '../../actions/RaffleFormActions';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';
import Layout from '../../components/Layout';
import SecuredPaymentInfo from '../../components/blocks/raffleForm/SecuredPaymentInfo';
import PageNotFound from '../../components/PageNotFound';
import RaffleInfo from '../../components/blocks/raffleForm/RaffleInfo';
import RegistrationForm from '../../components/blocks/raffleForm/RegistrationForm';
import { resetAction } from '../../actions/RegistrationFormActions';
import Countries from '../../enums/Countries';
import MetaTags from 'react-meta-tags';

/**
 * @property {Raffle} props.raffle
 * @property {boolean} props.raffleNotFound
 * @property {boolean} props.fetching
 * @property {Function} props.fetchConsents
 * @property {Function} props.fetchRaffle
 * @property {Function} props.fetchCountries
 */
class RaffleForm extends Component {

	static fetchData(store, match) {
		const id = match.params.raffleId;
		if (id) {
			return [
				store.dispatch(RaffleRepository.fetchRaffle(id, fetchingRaffleAction, fetchedRaffleAction)),
				store.dispatch(ConsentRepository.fetchConsents()),
				store.dispatch(DeliveryRepository.fetchCountries())
			];
		}
		// This will result in 404 (raffleNotFound=true)
		store.dispatch(fetchedRaffleAction(null));
		return [];
	}

	static getHtmlHeadFragment() {
		return '<title>Footshop - Releases</title><meta name="description" content=""/>';
	}

	/**
	 * @param {?string} id
	 * @this RaffleForm
	 */
	fetchRaffleIfRequired = (id) => {
		if (id === null) {
			return;
		}

		if (this.props.raffle) {
			this.props.clearFetchedRaffleAction(null);
		}

		this.props.fetchRaffle(id, fetchingRaffleAction, fetchedRaffleAction);
	};

	/**
	 * Note that fetch initial data is handled separately in server.js
	 */
	componentDidMount() {
		const { raffleId, registrationId, country } = this.props.match.params;

		// adyen repeat payment use case
		const raffleID = raffleId || this.props.registration.raffleId;

		this.fetchRaffleIfRequired(raffleID);

		if (this.props.isAdyenRepeatPayment) {
			return;
		}

		if (!registrationId) {
			this.props.resetAction();
		}

		let promises = [
			this.props.fetchConsents(),
			this.props.fetchCountries()
		];

		if (registrationId && country && country.toUpperCase() === Countries.ROMANIA.value) {
			// If this registration has Romania country selected, then we have to preload romanian counties and cities
			promises.push(this.props.fetchRomanianCountiesAndCities());
		}

		Promise.all(promises);
	}

	render({ route, location, match, registration, raffle, raffleNotFound, consents, countries, fetching, activeStep, deliveryService, fields, isAdyenRepeatPayment }) {
		if (raffleNotFound) {
			return <PageNotFound {...{ route, location }} />;
		}

		if (!raffle || (!isAdyenRepeatPayment && (fetching || !consents || !countries))) {
			return (
				<Layout {...{ route, location }}>
					<div className="abs-vertical-center">
						<LoadingSpinner active />
					</div>
				</Layout>
			);
		}

		const sizeId = isAdyenRepeatPayment ? registration.sizerunId : match.params.sizeId;
		const sex = isAdyenRepeatPayment ? raffle.getSizeSet(registration.sizerunId).name : match.params.sex;

		const selectedCountry = fields.country.value;

		return (
			<Layout {...{ route, location }}>
				<MetaTags>
					<title>{route.metaTitle}</title>
					<meta name="description" content="" />
				</MetaTags>
				<SecuredPaymentInfo />
				<div className={style.form}>
					<RaffleInfo {...{ raffle, sex, sizeId, activeStep, deliveryService, selectedCountry }} />
					<RegistrationForm />
				</div>
			</Layout>
		);
	}
}

const mapStateToProps = (state) => {
	const { raffleForm, adyenPayment } = state;
	return {
		activeStep: raffleForm.activeStep,
		raffle: raffleForm.raffle,
		deliveryService: raffleForm.deliveryService,
		consents: raffleForm.consents,
		countries: raffleForm.countries,
		raffleNotFound: raffleForm.raffleNotFound,
		fetching: raffleForm.fetchingRaffle || raffleForm.fetchingConsents || raffleForm.fetchingCountries,
		fields: raffleForm.fields,
		isAdyenRepeatPayment: adyenPayment.isAdyenRepeatPayment
	};
};

// TODO: Merge into compound fetch request!
const mapDispatchToProps = (dispatch) => bindActionCreators({
	fetchRaffle: RaffleRepository.fetchRaffle,
	fetchRomanianCountiesAndCities: DeliveryRepository.fetchRomanianCountiesAndCities,
	fetchConsents: ConsentRepository.fetchConsents,
	fetchCountries: DeliveryRepository.fetchCountries,
	clearFetchedRaffleAction,
	resetAction
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RaffleForm);



// WEBPACK FOOTER //
// ./routes/raffle/RaffleForm.js